import { IDataContextProvider } from "@contexts/data/types";
import { ITicketsTableRequestModel, TicketStatus } from "@pages/enquiryInbox/enquiryInbox.types";

export const enquiryInboxService = (dataProvider: IDataContextProvider) => ({
  loadTickets: async (ticketStatus: TicketStatus, dataTableRequest: ITicketsTableRequestModel) => {
    const baseUrl = dataProvider.getApiUrl();
    return await dataProvider
      .custom?.({
        method: "post",
        url: `${baseUrl}/enquiries/tickets/${ticketStatus}`,
        payload: dataTableRequest,
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((result) => {
        return result?.data;
      });
  },

  searchTickets: async (
    status: string,
    isEscalation: boolean,
    enquiryType: string,
    searchKeyword: string,
    dataTableRequest: ITicketsTableRequestModel,
    fromDate?: string,
    toDate?: string
  ) => {
    const baseUrl = dataProvider.getApiUrl();

    // Build query parameters using URLSearchParams for cleaner code
    const queryParams = new URLSearchParams();

    if (status) {
      queryParams.append("status", status);
    }

    if (!isEscalation && enquiryType) {
      queryParams.append("enquiryType", enquiryType);
    }

    if (fromDate) {
      queryParams.append("dateFrom", fromDate);
    }

    if (toDate) {
      queryParams.append("dateTo", toDate);
    }

    const queryString = queryParams.toString();
    const urlWithParams = `${baseUrl}/enquiries/search-tickets/${isEscalation}/${searchKeyword || ""}${queryString ? `?${queryString}` : ""}`;

    return await dataProvider
      .custom?.({
        method: "post",
        url: urlWithParams,
        payload: dataTableRequest,
      })
      .then((result) => {
        return result?.data;
      });
  },
  viewTicket: async (ticketId: bigint) => {
    const baseUrl = dataProvider.getApiUrl();

    return await dataProvider
      .custom?.({
        method: "get",
        url: `${baseUrl}/enquiries/${ticketId}`,
      })
      .then((result) => {
        return result?.data;
      });
  },
  updateTicket: async (ticketId: number, model: any) => {
    const baseUrl = dataProvider.getApiUrl();

    const url = `${baseUrl}/enquiries/${ticketId}/update`;

    return dataProvider
      .custom?.({
        method: "post",
        url: url,
        payload: model,
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "*/*",
        },
      })
      .then((result) => {
        return result?.data;
      });
  },
  loadSummary: async () => {
    const baseUrl = dataProvider.getApiUrl();

    return await dataProvider
      .custom?.({
        method: "get",
        url: `${baseUrl}/enquiries/summary`,
      })
      .then((result) => {
        return result?.data;
      });
  },
});
